module.exports = __webpack_public_path__ + "img/dailyInnovation.46553dfd.png";